
import { User } from "interfaces/user"
import { UserActionType } from "../action-types/userTypes"
import { Action } from "../actions/userActions"
import { PaginatedModel } from "interfaces/pagination"

const initialState: PaginatedModel<User> = {
    paginatorInfo: {
        currentPage: 1,
        perPage: 30,
        lastPage: 1,
        total: 0
    },
    data: []
}

const reducer = (state: PaginatedModel<User> = initialState, action: Action) => {
    switch (action.type) {
        case UserActionType.PAGINATE_USERS:
            return action.payload;
        case UserActionType.CREATE_USER:
            return {
                ...state,
                data: [action.payload, ...state.data]
            };
        case UserActionType.UPDATE_USER:
            return {
                ...state,
                data: state.data.map(st => {
                    if(st.id === action.payload.id) st = action.payload
                    return st
                })
            }
        case UserActionType.DELETE_USER:
            return {
                ...state,
                data: state.data.filter(st => st.id !== action.payload)
            }
        default:
            return state
    }
}

export default reducer